import { connect } from 'react-redux'
import * as loginActions from '../actions/login'
import { loadLocale } from '../actions/i18n'
import LoginWidget from '../components/LoginWidget'

const mapStateToProps = (state, ownProps) => ({
	isLoggedIn: state.login.isLoggedIn,
	environment: state.login.environment,
	username: state.login.username,
	error: state.login.error,
	isLoading: state.login.isLoading,
	locale: state.i18n.locale
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onLogin: (username, password) => dispatch(loginActions.login(username, password)),
	onLogout: () => dispatch(loginActions.logout()),
	onLocaleChange: (value) => dispatch(loadLocale(value))
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LoginWidget)



// WEBPACK FOOTER //
// ./src/containers/LoginContainer.js